import { Link } from "react-router-dom";
import "../styles/NotFound.css";

export default function NotFound() {
  return (
    <div className="nf">
      <h1 className="nf-title">ops...</h1>
      <p className="nf-description">
        Parece que a página que você acessou não existe. Clique <Link to="/">aqui</Link> para voltar para a página principal
      </p>
    </div>
  )
}
